const PositionTypes = {
    ADD_VOTE:'ADD-VOTE',
    SENATE_VOTE:'SENATE_VOTE',
    FETCH_POSITION_START:"FETCH_POSITIONS_START",
    FETCH_POSITION_SUCCESS:"FETCH_POSITIONS_SUCCESS",
    FETCH_POSITION_FAILURE:"FETCH_POSITIONS_FAILURE"
}

export default PositionTypes